module.exports = lodash;


//////////////////
// WEBPACK FOOTER
// external "lodash"
// module id = 5
// module chunks = 0